<!-- 模板库首页 -->
<template>
  <div class="templates">
    <div class="controls">
      <div class="add">
        <el-button
          v-if="$hasPermission('tempalteCreate')"
          type="success"
          icon="el-icon-plus"
          circle
          @click="addTemplateForm"
        />
      </div>
      <div class="search">
        <el-input
          v-model="searchText"
          placeholder="请输入模板名称"
          @keyup.enter.native="$router.replace({ query: { name: searchText } })"
        >
          <i
            slot="prefix"
            class="el-input__icon el-icon-search"
          />
        </el-input>
      </div>
    </div>

    <div class="content">
      <div
        v-if="templates.length > 0"
        class="template-list"
      >
        <div
          v-for="template in templates"
          :key="template.id"
          class="template"
        >
          <div class="cover">
            <div v-if="template.httpUrl">
              <router-link
                :to="{
                  name: 'templatePreview',
                  params: { templateId: template.id }
                }"
              >
                <img
                  :src="template.cover"
                  alt
                >
                <div class="name">
                  {{ template.name }}
                </div>
              </router-link>
            </div>
            <div v-else>
              <img
                :src="template.cover"
                alt
              >
              <div class="name">
                {{ template.name }}
              </div>
            </div>
          </div>
          <div class="control">
            <el-button
              v-if="$hasPermission('templateEdit')"
              size="mini"
              plain
              @click="editTpl(template.id)"
            >
              编辑
            </el-button>
            <el-button
              v-if="$hasPermission('templateDisable')"
              size="mini"
              plain
              @click="disabledTpl(template.id, !template.disabled)"
            >
              {{ template.disabled ? "上架" : "下架" }}
            </el-button>
            <el-button
              size="mini"
              plain
              @click="
                $router.push({
                  name: 'templateCodes',
                  params: { templateId: template.id }
                })
              "
            >
              代码库
            </el-button>
          </div>
        </div>

        <div
          v-if="hasMoreTemplates"
          class="next-page"
        >
          <el-button
            class="loading"
            type="text"
            @click="search({ page: page + 1 })"
          >
            加载更多
          </el-button>
        </div>
      </div>
      <span v-else>没有模板</span>
    </div>

    <!-- 添加模板弹窗 -->
    <el-dialog
      id="add-template-dialog"
      title="创建模板"
      :visible.sync="addTemplateDialogVisible"
    >
      <add-template
        :key="Date.now()"
        @cancel="cancelAdd()"
        @confirm="confirmAdd()"
      />
    </el-dialog>

    <!-- 编辑模板弹窗 -->
    <el-dialog
      id="edit-template-dialog"
      title="编辑模板"
      :visible.sync="editTemplatedialogVisible"
    >
      <edit-template
        :key="Date.now()"
        ref="editForm"
        :template-id="editTemplateId"
        @cancel="cancelEdit()"
        @confirm="confirmEdit()"
      />
    </el-dialog>
  </div>
</template>

<style lang="less" scoped>
// 控制层高度
@controls-height: 45px;
// 间隙
@gap-height: 15px;

@template-cover-width: 200px;
@template-cover-height: 112.3px;
.search .el-input__icon {
  cursor: pointer;
}
.view-dialog {
  position: fixed;
  top: 50%;
  bottom: 40px;
  background-color: #fff;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 375px;
  height: 667px;
  z-index: 20;
  border: 1px solid #333;
  overflow-y: visible;
  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }
}
.el-dialog {
  width: 80%;
}
.templates {
  .controls {
    min-height: @controls-height;
    line-height: @controls-height;
    margin-bottom: @gap-height;

    .add,
    .select-tab,
    .search {
      display: inline-block;
      margin-right: 18px;
    }

    .search {
      float: right;
    }

    .tags {
      margin: 10px 0;
      line-height: 1.8;
    }
  }

  .content {
    .template-list {
      // TODO 两端对齐无效
      text-align: justify;

      .template {
        display: inline-block;
        width: 200px;
        padding: 7px;
        margin-right: 15px;
        margin-bottom: 15px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 3px;

        .cover {
          position: relative;
          margin-bottom: 7px;
          img {
            display: block;
            width: @template-cover-width;
            height: @template-cover-height;
          }

          .name {
            position: absolute;
            bottom: 0;
            padding: 5px 0;
            text-indent: 7px;
            width: 100%;
            color: white;
            background-color: rgba(0, 0, 0, 0.3);
          }
        }
      }

      .next-page {
        text-align: center;
        .loading {
          color: #409eff;
        }
      }
    }

    .template-list::after {
      content: "";
      display: inline-block;
      width: 100%;
    }
  }

  #add-template-dialog,
  #edit-template-dialog {
    .cover-uploder {
      width: @template-cover-width;
      height: @template-cover-height;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      margin: 0 auto 22px;
      text-align: center;
      line-height: @template-cover-height;

      // TODO 不生效
      .el-upload {
        display: block;
      }

      .cover-uploder-icon {
        font-size: 28px;
        color: #8c939d;
        vertical-align: middle;
      }

      .cover-preview {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .cover-uploder:hover {
      border-color: #ebb712;
    }

    .tempalte-tag {
      margin-right: 5px;
    }

    .input-new-template-tag {
      display: inline-block;
      height: 39px;
      width: 79px;
    }
  }
}
</style>

<script>
const debug = require('debug')('ccs:ctrl:template');
import axios from 'axios';
import addTemplate from './template_add';
import editTemplate from './template_edit';

export default {
	components: {
		addTemplate,
		editTemplate
	},
	data() {
		return {
			searchText: '', // 搜索文本
			// 控制属性
			// 添加模板弹出框是否可见
			addTemplateDialogVisible: false,
			// 编辑模板弹出框是否可见
			editTemplatedialogVisible: false,
			// 模板标签输入框是否课件
			addTemplateTagInputVisible: false,
			// 当前第几页
			page: 1,
			// 一共多少页
			pages: 0,

			editTemplateId: '', //当前编辑模板id

			// 模板列表
			templates: [],

			// 添加/编辑 模板属性
			editData: {}, //编辑模板接口所需参数
			viewTplUrl: '',
			isShowView: false,
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			}
		};
	},

	computed: {
		// 是否有更多
		hasMoreTemplates: function() {
			return this.pages > this.page;
		}
	},

	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: async function() {
			return this.search();
		},
		// 若编辑模板id变更，则其UI组件内部需要重新发起请求
		editTemplateId(newVal, oldVal) {
			if (newVal) {
				this.$refs.editForm && this.$refs.editForm.init();
			}
		}
	},

	async created() {
		return this.search();
	},

	methods: {
		// 搜索
		// 需要刷新保留的查询条件放置到 query 上面 其它放置到参数中
		async search(query = {}) {
			Object.assign(query, this.$route.query);
			debug('[search] query: %o', query);

			const { page, pages, data } = await axios.get('/api/templates', {
				params: query
			});

			if (page === 1) {
				this.templates = data;
			} else {
				this.templates.push(...data);
			}
			this.page = page;
			this.pages = pages;
		},

		// 添加模板
		addTemplateForm() {
			this.addTemplateDialogVisible = true;
		},

		// 取消添加
		cancelAdd() {
			this.addTemplateDialogVisible = false;
			this.search();
		},

		// 确定添加
		confirmAdd() {
			this.addTemplateDialogVisible = false;
			this.search();
		},

		// 编辑模板
		async editTpl(templateId) {
			this.editTemplatedialogVisible = true;
			this.editTemplateId = templateId;
		},

		// 取消模板编辑
		cancelEdit() {
			this.editTemplatedialogVisible = false;
			this.search();
		},

		// 提交模板编辑
		confirmEdit() {
			this.editTemplatedialogVisible = false;
			this.search();
		},

		// 上下架模板
		async disabledTpl(templateId, disabled) {
			await axios.put(`/api/templates/${templateId}/disabled`, {
				disabled: disabled
			});
			await this.search();
		}
	}
};
</script>
